import axios from "axios";

export const fetchRestrictedEmailDomains = async (): Promise<string> => {
  const { data } = await axios.get<string>(
    "https://dgk28ckagqims.cloudfront.net/mission-control/PageRegister/email_provider_domains.txt",
    {
      headers: {
        "Content-Type": "text/plain",
      },
    }
  );

  return data;
};
